var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',[_c('os-sheet-content',[_c('os-participant-global-overview',{staticClass:"minimal-critical-height",attrs:{"participants":_vm.participants,"loading":_vm.loading},on:{"rowclicked":(e) => _vm.rowClicked(e)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }